import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => {
  return {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "flex-start",
      border: `1px solid ${theme.palette.background.gray_200}`,
      maxWidth: "433px",
      borderRadius: "12px",
      backgroundColor: theme.palette.utility.utility_gray_50,
    },
    contactName: {
      fontSize: "24px",
      fontWeight: 600,
      color: theme.palette.text.primary,
    },
    contactType: {
      fontSize: "16px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
    },
    creationLabel: {
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.secondary,
    },
    creationTime: {
      fontSize: "14px",
      fontWeight: 500,
      color: theme.palette.text.primary,
    },
    contactCreator: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
    },
    summaryTitle: {
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      paddingBottom: "20px",
      width: "100%",
      borderBottom: `1px solid ${theme.palette.border.secondary}`,
    },
    card: {
      padding: "24px",
      borderRadius: "12px 12px 0 0 !important",
      maxWidth: "433px",
    },
    corprateCard: {
      borderRadius: "12px !important",
    },
    avatarWrapper: {
      position: "relative",
      alignItems: "center",
      backgroundColor: "#FFF",
      borderRadius: theme.borderRadius[10],
      boxShadow: theme.shadows[4],
      display: "flex",
      height: "104px",
      width: "104px",
      justifyContent: "center",
    },
    defaultAvatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "96px",
      width: "96px",

      "& img": {
        height: "48px",
        width: "48px",
      },
    },
    avatar: {
      background: theme.palette.background.secondary_hover,
      border: `1px solid ${theme.palette.border.avatarContrast}`,
      height: "96px",
      width: "96px",
      "& img": {
        objectFit: "contain",
      },
    },
    contactDetailsContainer: {
      display: "flex",
      alignItems: "center",
      gap: "20px",
    },
    contactDetails: {
      display: "flex",
      gap: "8px",
      flexDirection: "column",
    },
    summaryContainer: {
      padding: "24px",
      width: "100%",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    summaryDetails: {
      display: "flex",
      flexDirection: "column",
      gap: "12px",
    },
    summaryField: {
      display: "flex",
      gap: "16px",

      "& *": {
        fontSize: "16px",
        fontWeight: 500,
        color: theme.palette.text.secondary,
      },
      "& * + *": {
        fontSize: "16px",
        fontWeight: 600,
      },
    },
  };
});
